import { render, staticRenderFns } from "./RewardPeriodDetail.vue?vue&type=template&id=a064de70"
import script from "./reward-period-detail.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-detail.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period-detail.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports